// AUT-245 §9: exact tooltip copy from the developer brief. Kept verbatim and in one place
// so the methodology reaches the UI unchanged.
export const BI_TOOLTIPS = {
  // Header. BSR threshold is the value the report was built with, not a hardcoded number.
  categoryCount: (bsr: number) =>
    `Number of Amazon categories where this brand has at least one qualifying product (BSR under ${bsr.toLocaleString()} in its root category).`,
  otherCategoryCount: (bsr: number) =>
    `Number of Amazon categories outside the primary category or niche where this brand has at least one qualifying product (BSR under ${bsr.toLocaleString()} in its root category).`,
  asinCount:
    "Total ASINs across the brand's full catalog meeting the BSR threshold, including products not yet added to Signal.",
  trailingRevenue: "Estimated Amazon revenue across the brand's full catalog over the last 12 months.",
  lastRefreshed:
    "Category and competitor data updates monthly regardless of refresh clicks. Keyword rank and AI visibility data can update as often as weekly.",

  // Categories tab
  paidSov:
    "Share of page-1 sponsored placements held by this brand, across the category's top 50 keywords. Reflects page 1 only. Organic SOV, by comparison, is measured across the first 100 organic positions, roughly 7 pages. Amazon's sponsored placement data doesn't carry a single position across pages the way organic rank does, so deeper-page sponsored activity isn't included.",
  organicSov:
    "Brand's share of organic search visibility across this category's top 50 keywords, weighted by ranking position.",
  totalSov:
    "Paid SOV plus Organic SOV. These are two independent measurements from different data sources shown together, not a single unified calculation.",
  brandVisibility:
    "Revenue-weighted average Amazon AI Score across the brand's ASINs in this category. Only reflects ASINs added to Signal.",
  status:
    "Strong, Gaps, or Needs work, based on this category's SOV, revenue share, and growth relative to the brand's other tracked categories.",
  productSignalColumns: "Not available until this product is added to Signal.",

  // Competitors tab
  segment:
    "Competitive brands are priced within 25% of this brand's average price in the category. Broad includes every brand in the category's top 50 ASINs by revenue, regardless of price.",
  trendMoM: "Change from last month to this month. Moves smaller than 0.3 points show as flat.",

  // Keyword SOV tab
  kwRevenue:
    "Estimated monthly revenue attributable to this keyword, based on search volume and ranking position across the category.",
  contributionToKeywordSov:
    "How much each product contributes to the brand's total Organic SOV on this keyword. Contributions sum to the brand total shown in the matrix above.",

  // AI Visibility tab
  mentionShare:
    "Brand's share of mentions across tracked AI platforms relative to its competitor set, based on how often the brand is mentioned, not a ranked position, since AI answers aren't a sorted list the way a search results page is.",
  platformBreakdown:
    "Mention rate by platform, compared to the competitor set's average. Excludes probe responses that were refusals, off-topic, or errors.",
} as const;
